import { combineEpics } from 'redux-observable';
import getDismissedEpic from './get-dismissed/index.tsx';
import setDismissedEpic from './set-dismissed/index.tsx';

// @ts-expect-error - TS2769: Type 'void' is not assignable to type 'BoardIssueMoveShowAction'.
export default combineEpics(getDismissedEpic, setDismissedEpic);
